import { homeIcon } from '@progress/kendo-svg-icons';
import { ExtendedDrawerItem, LayoutConfig } from '../../../core/components/app-layout/layout-config';
import { User } from '../../../core/models/user';

const ONE_GROUPS = ['admin', 'partner_admin', 'customer'];

export function buildPartnerNavItems(): ExtendedDrawerItem[] {
  return [{ id: 0, text: 'Home', svgIcon: homeIcon, path: '/partner/home' }];
}

/** Only users with a ONE role have somewhere to go back to. */
export function hasOne(user: User): boolean {
  return (user.groups ?? []).some((group) => ONE_GROUPS.includes(group));
}

/** ONE's dashboard for the user's own organization, used when no ONE page is remembered. */
export function oneDashboardUrl(user: User): string {
  const org = user.primary_organization;
  const params = new URLSearchParams();
  if (org?.id) params.set('organizationId', String(org.id));
  if (org?.account_type) params.set('account_type', String(org.account_type));
  const query = params.toString();
  return `/customer/customer-dashboard${query ? `?${query}` : ''}`;
}

export const partnerLayoutConfig: LayoutConfig = {
  menuItemsFactory: () => buildPartnerNavItems(),

  footer: {
    showVipSupport: false,
    showResources: false,
    showNotifications: false,
    showSettings: false,
    showUserAvatar: true,
  },

  userMenuItemsFactory: () => [{ text: 'Logout', icon: 'log-out' }],

  // The portal is about the user's own partner org; there is nothing to switch.
  onOrgChange: () => undefined,
  showOrgPicker: false,

  workspace: 'partner',
  sandbox: {
    label: 'Partner Portal',
    returnTo: {
      label: 'Return to Cyflare ONE',
      workspace: 'one',
      available: hasOne,
      home: oneDashboardUrl,
    },
  },
  settingsRoute: null,
  resourceLinks: [],

  scripts: {
    injectZoho: false,
    removeChatWidget: true,
  },
};
